<template>
  <div>
    <SidebarVue />
    <NavgatorDk
      ref="navgator"
      :barraTitulo="' Informações do Cliente'"
      :titulo="'reimprimir menu'"
    />

    <!--Reimprimir a vista-->
    <div v-if="this.a_vista">
      <div class="modal-dialog modal-fullscreen rf_modal font-pdf-menu">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <div class="container_pdf" ref="contentToPrint2">
              <div class="card-body">
                <div class="row">
                  <div class="col-6">
                    <a class="navbar-brand logo">
                      <img
                        src="../../assets/logo.png"
                        alt="Bootstrap"
                        class="logo-pdf"
                      />
                    </a>
                  </div>
                  <div class="col-6" style="text-align: right">
                    <a class="navbar-brand logo_cliente">
                      <img
                        src="../../assets/logo.png"
                        alt="Bootstrap"
                        class="logo-pdf"
                      />
                    </a>
                  </div>
                </div>
                <!-- Primeiro Bloco-->
                <div class="row g-2">
                  <div class="col-md-6 col-lg-4 col-xl-4">
                    <div class="card card-pdf border-secondary mb-2">
                      <div class="card-header header_pdf_txt">
                        <i class="bi bi-person-bounding-box ico-pdf"></i>
                        Informações do Cliente
                      </div>
                      <div class="card-body">
                        <p class="card-text-pdf">
                          <strong>CLIENTE:</strong>
                          <span class="texto_menu_desk_pdf">{{
                            g_menu_cliente
                          }}</span>
                        </p>
                        <p class="card-text-pdf">
                          <strong>CPF/CNPJ:</strong>
                          <span class="texto_menu_desk_pdf">{{
                            g_menu_cpfCnpj
                          }}</span>
                        </p>
                        <p class="card-text-pdf">
                          <strong>FONE:</strong>
                          <span class="texto_menu_desk_pdf">{{
                            g_menu_fone
                          }}</span>
                          /
                          <span class="texto_menu_desk_pdf">{{
                            g_menu_fone2
                          }}</span>
                        </p>

                        <p class="card-text-pdf">
                          <strong>EMAIL:</strong>
                          <span class="texto_menu_desk_pdf">{{
                            g_menu_email
                          }}</span>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-3 col-xl-3">
                    <div class="card card-pdf border-secondary mb-2">
                      <div class="card-header header_pdf_txt">
                        <i class="bi bi-file-earmark-text ico-pdf"></i>
                        Informações da Proposta
                      </div>
                      <div class="card-body">
                        <p class="card-text-pdf">
                          <strong>GERENTE:</strong
                          ><span class="texto_menu_desk_pdf">{{
                            g_menu_gerente
                          }}</span>
                        </p>
                        <p class="card-text-pdf">
                          <strong>VENDEDOR:</strong
                          ><span class="texto_menu_desk_pdf">{{
                            g_menu_vendedor
                          }}</span>
                        </p>
                        <p class="card-text-pdf">
                          <strong>NEGOCIAÇÃO:</strong
                          ><span class="texto_menu_desk_pdf">{{
                            g_menu_negociacao
                          }}</span>
                        </p>
                        <p class="card-text-pdf">
                          <strong>DATA:</strong
                          ><span class="texto_menu_desk_pdf">{{
                            g_menu_data_negociacao
                          }}</span>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-5 col-xl-5">
                    <div class="card card-pdf border-secondary mb-2">
                      <div class="card-header header_pdf_txt">
                        <i class="bi bi-car-front-fill ico-pdf"></i>
                        Veículo de Troca
                      </div>
                      <div>
                        <ul class="list-group">
                          <li
                            v-for="item in veiculos_avaliados"
                            :key="item.id"
                            class="list-group-item texto_menu_desk_pdf"
                          >
                            <div class="row">
                              <div class="col">
                                <span class="header_pdf_txt">Marca</span>
                              </div>
                              <div class="col">
                                <span class="header_pdf_txt">Modelo</span>
                              </div>
                              <div class="col">
                                <span class="header_pdf_txt">Placa</span>
                              </div>
                              <div class="col">
                                <span class="header_pdf_txt">Avaliado</span>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col">
                                <span class="texto_menu_desk_pdf">{{
                                  item.marca
                                }}</span>
                              </div>
                              <div class="col">
                                <span class="texto_menu_desk_pdf">{{
                                  item.modelo
                                }}</span>
                              </div>
                              <div class="col">
                                <span class="texto_menu_desk_pdf">{{
                                  item.placa
                                }}</span>
                              </div>
                              <div class="col">
                                <span class="texto_menu_desk_pdf">{{
                                  item.preco_avaliado
                                }}</span>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>

                <!-- Segundo Bloco-->
                  <div class="col-md-6 col-lg-4 col-xl-4">
                    <div class="card card-pdf border-secondary">
                      <div class="card-header header_pdf_txt">
                        <i class="bi bi-card-checklist ico-pdf"></i>
                        INFORMAÇÕES DO VEÍCULO
                      </div>
                      <div class="card-body text-secondary">
                        <p class="card-text-pdf">
                          <strong>MARCA:</strong
                          ><span class="texto_menu_desk_pdf">{{
                            g_menu_marca
                          }}</span>
                        </p>
                        <p class="card-text-pdf">
                          <strong>MODELO:</strong>
                          <span class="texto_menu_desk_pdf">{{
                            g_menu_modelo
                          }}</span>
                        </p>
                        <p class="card-text-pdf">
                          <strong>COR:</strong
                          ><span class="texto_menu_desk_pdf">{{
                            g_menu_cor
                          }}</span>
                        </p>
                        <div class="row">
                          <div class="col-5">
                            <p class="card-text-pdf">
                              <strong>PLACA:</strong>
                              <span class="texto_menu_desk_pdf">{{
                                g_menu_placa
                              }}</span>
                            </p>
                          </div>
                          <div class="col-7">
                            <p class="card-text-pdf">
                              <strong>CHASSI:</strong
                              ><span class="texto_menu_desk_pdf">{{
                                g_menu_chassi
                              }}</span>
                            </p>
                          </div>
                        </div>

                        <p class="card-text-pdf">
                          <strong>ANO:</strong
                          ><span class="texto_menu_desk_pdf">{{
                            g_menu_ano_modelo
                          }}</span>
                          /
                          <span class="texto_menu_desk_pdf">{{
                            g_menu_ano_fab
                          }}</span>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-4 col-xl-4">
                    <div class="card card-pdf border-secondary mb-2">
                      <div class="card-header header_pdf_txt">
                        <i class="bi bi-receipt-cutoff ico-pdf"></i>
                        RESUMO DA COMPRA
                      </div>
                      <div class="card-body text-secondary">
                        <p class="card-text-pdf">
                          <strong>VALOR SUGERIDO:</strong
                          ><span class="texto_menu_desk_pdf">{{
                            g_menu_val_sugerido
                          }}</span>
                        </p>
                        <p class="card-text-pdf">
                          <strong>DESCONTO:</strong
                          ><span class="texto_menu_desk_pdf">{{
                            g_menu_val_desconto
                          }}</span>
                        </p>

                        <p class="card-text-pdf">
                          <strong>TOTAL VEÍCULO:</strong>
                          <span class="texto_menu_desk_pdf">{{
                            g_menu_val_veiculo
                          }}</span>
                        </p>
                        <p class="card-text-pdf">
                          <strong>TOTAL VU:</strong>
                          <span class="texto_menu_desk_pdf">{{
                            this.currency(this.valor_avaliacao)
                          }}</span>
                        </p>
                        <p class="card-text-pdf">
                          <strong>FINANCIAMENTO:</strong
                          ><span class="texto_menu_desk_pdf">{{
                            g_menu_total_financiado
                          }}</span>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-4 col-xl-4">
                    <div class="card card-pdf border-secondary mb-2">
                      <div class="card-header header_pdf_txt">
                        <i class="bi bi-chat-square-text-fill ico-pdf"></i>
                        OBSERVAÇÕES
                      </div>
                      <div class="card-body text-secondary">
                        <p class="card-text-pdf">
                          <span class="texto_menu_desk_pdf">{{
                            info_adicionais
                          }}</span>
                        </p>
                      </div>
                    </div>
                  </div>
                   <div class="col-12">
                    <div class="card card-pdf-1 border-secondary mb-2">
                      <div class="card-header header_pdf_txt">
                        <i class="bi bi-wallet2 ico-pdf"></i>Composição do
                        Pagamento
                      </div>
                      <div class="card-body p-0">
                        <!-- Removido padding para melhor ajuste -->
                        <div class="pagamento-grid">
                          <!-- Container grid -->
                          <div
                            v-for="item in itens_pagamentos"
                            :key="item.id"
                            class="pagamento-item"
                          >
                            <div
                                  class="texto_menu_desk_pdf"
                                  style="font-weight: bold"
                                >
                                  {{ currency(item.valor_parcela) }}
                                </div>
                                <div
                                  class="texto_menu_desk_pdf"
                                  style="font-size: 10px"
                                >
                                  {{ item.tipo_pagamento_descricao }}
                                </div>
                                <div
                                  class="texto_menu_desk_pdf"
                                  style="font-size: 10px"
                                >
                                  {{ item.qtd_parcela }}x
                                </div>


                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>


                <!--Mensagem Rodapé-->
                <div class="row g-2 p-2">
                  <div class="col-md-12 col-lg-12 col-xl-12">
                    <p
                      class="card-text-2"
                      v-for="(text, index) in disclaimer_texts"
                      :key="index"
                    >
                      {{ text }}
                    </p>
                  </div>
                </div>

                <div class="row g-2 p-2 mt-0">
                  <div class="col rf_assinatura">
                    <span class="texto_menu_desk_pdf"
                      ><strong>Gerente:</strong> {{ g_menu_gerente }}</span
                    >
                  </div>
                  <div class="col rf_assinatura">
                    <span class="texto_menu_desk_pdf"
                      ><strong>Cliente:</strong> {{ g_menu_cliente }}</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-footer">
        <div class="row">
          <div class="col-md-6 col-lg-6 col-xl-6">
            <button
              type="button"
              class="btn btn-form"
              onclick="window.location.href='/desk/indexGerente'"
            >
              Fechar
            </button>
          </div>
          <div class="col-md-6 col-lg-6 col-xl-6">
            <button class="btn btn-form" @click="generatePdfAvista">
              IMPRIMIR
            </button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="this.por_financiamento">
      <div class="modal-dialog modal-fullscreen rf_modal font-pdf-menu">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <div class="container_pdf" ref="contentToPrint">
              <div class="card-body">
                <div class="row">
                  <div class="col-6">
                    <a class="navbar-brand logo">
                      <img
                        src="../../assets/logo.png"
                        alt="Bootstrap"
                        class="logo-pdf"
                      />
                    </a>
                  </div>
                  <div class="col-6" style="text-align: right">
                    <a class="navbar-brand logo_cliente">
                      <img
                        src="../../assets/logo.png"
                        alt="Bootstrap"
                        class="logo-pdf"
                      />
                    </a>
                  </div>
                </div>
                <!-- Primeiro Bloco-->
                <div class="row g-2">
                  <div class="col-4">
                    <div class="card card-pdf border-secondary mb-1">
                      <div class="card-header header_pdf_txt">
                        <i class="bi bi-person-bounding-box ico-pdf"></i>
                        Informações do Cliente
                      </div>
                      <div class="card-body">
                        <p class="card-text-pdf">
                          <strong>CLIENTE:</strong>
                          <span class="texto_menu_desk_pdf">{{
                            g_menu_cliente
                          }}</span>
                        </p>
                        <p class="card-text-pdf">
                          <strong>CPF/CNPJ:</strong>
                          <span class="texto_menu_desk_pdf">{{
                            g_menu_cpfCnpj
                          }}</span>
                        </p>
                        <p class="card-text-pdf">
                          <strong>FONE:</strong>
                          <span class="texto_menu_desk_pdf">{{
                            g_menu_fone
                          }}</span>
                          /
                          <span class="texto_menu_desk_pdf">{{
                            g_menu_fone2
                          }}</span>
                        </p>

                        <p class="card-text-pdf">
                          <strong>EMAIL:</strong>
                          <span class="texto_menu_desk_pdf">{{
                            g_menu_email
                          }}</span>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="col-3">
                    <div class="card card-pdf border-secondary mb-2">
                      <div class="card-header header_pdf_txt">
                        <i class="bi bi-file-earmark-text ico-pdf"></i>
                        Informações da Proposta
                      </div>
                      <div class="card-body">
                        <p class="card-text-pdf">
                          <strong>GERENTE:</strong
                          ><span class="texto_menu_desk_pdf">{{
                            g_menu_gerente
                          }}</span>
                        </p>
                        <p class="card-text-pdf">
                          <strong>VENDEDOR:</strong
                          ><span class="texto_menu_desk_pdf">{{
                            g_menu_vendedor
                          }}</span>
                        </p>
                        <p class="card-text-pdf">
                          <strong>NEGOCIAÇÃO:</strong
                          ><span class="texto_menu_desk_pdf">{{
                            g_menu_negociacao
                          }}</span>
                        </p>
                        <p class="card-text-pdf">
                          <strong>DATA:</strong
                          ><span class="texto_menu_desk_pdf">{{
                            g_menu_data_negociacao
                          }}</span>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="col-5">
                    <div class="card card-pdf border-secondary mb-2">
                      <div class="card-header header_pdf_txt">
                        <i class="bi bi-car-front-fill ico-pdf"></i>
                        Veículo de Troca
                      </div>
                      <div>
                        <ul class="list-group">
                          <li
                            v-for="item in veiculos_avaliados"
                            :key="item.id"
                            class="list-group-item texto_menu_desk_pdf"
                          >
                            <div class="row">
                              <div class="col">
                                <span class="header_pdf_txt">Marca</span>
                              </div>
                              <div class="col">
                                <span class="header_pdf_txt">Modelo</span>
                              </div>
                              <div class="col">
                                <span class="header_pdf_txt">Placa</span>
                              </div>
                              <div class="col">
                                <span class="header_pdf_txt">Avaliado</span>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col">
                                <span class="texto_menu_desk_pdf">{{
                                  item.marca
                                }}</span>
                              </div>
                              <div class="col">
                                <span class="texto_menu_desk_pdf">{{
                                  item.modelo
                                }}</span>
                              </div>
                              <div class="col">
                                <span class="texto_menu_desk_pdf">{{
                                  item.placa
                                }}</span>
                              </div>
                              <div class="col">
                                <span class="texto_menu_desk_pdf">{{
                                  item.preco_avaliado
                                }}</span>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Segundo Bloco-->
                <div class="row g-2">
                  <div class="col-4">
                    <div class="card card-pdf border-secondary mb-1">
                      <div class="card-header header_pdf_txt">
                        <i class="bi bi-card-checklist ico-pdf"></i>
                        INFORMAÇÕES DO VEÍCULO
                      </div>
                      <div class="card-body text-secondary">
                        <p class="card-text-pdf">
                          <strong>MARCA:</strong
                          ><span class="texto_menu_desk_pdf">{{
                            g_menu_marca
                          }}</span>
                        </p>
                        <p class="card-text-pdf">
                          <strong>MODELO:</strong>
                          <span class="texto_menu_desk_pdf">{{
                            g_menu_modelo
                          }}</span>
                        </p>
                        <p class="card-text-pdf">
                          <strong>COR:</strong
                          ><span class="texto_menu_desk_pdf">{{
                            g_menu_cor
                          }}</span>
                        </p>
                        <div class="row">
                          <div class="col-5">
                            <p class="card-text-pdf">
                              <strong>PLACA:</strong>
                              <span class="texto_menu_desk_pdf">{{
                                g_menu_placa
                              }}</span>
                            </p>
                          </div>
                          <div class="col-7">
                            <p class="card-text-pdf">
                              <strong>CHASSI:</strong
                              ><span class="texto_menu_desk_pdf">{{
                                g_menu_chassi
                              }}</span>
                            </p>
                          </div>
                        </div>

                        <p class="card-text-pdf">
                          <strong>ANO:</strong
                          ><span class="texto_menu_desk_pdf">{{
                            g_menu_ano_modelo
                          }}</span>
                          /
                          <span class="texto_menu_desk_pdf">{{
                            g_menu_ano_fab
                          }}</span>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="card card-pdf border-secondary mb-1">
                      <div class="card-header header_pdf_txt">
                        <i class="bi bi-receipt-cutoff ico-pdf"></i>
                        RESUMO DA COMPRA
                      </div>
                      <div class="card-body text-secondary">
                        <p class="card-text-pdf">
                          <strong>VALOR SUGERIDO:</strong
                          ><span class="texto_menu_desk_pdf">{{
                            g_menu_val_sugerido
                          }}</span>
                        </p>
                        <p class="card-text-pdf">
                          <strong>DESCONTO:</strong
                          ><span class="texto_menu_desk_pdf">{{
                            g_menu_val_desconto
                          }}</span>
                        </p>

                        <p class="card-text-pdf">
                          <strong>TOTAL VEÍCULO:</strong>
                          <span class="texto_menu_desk_pdf">{{
                            g_menu_val_veiculo
                          }}</span>
                        </p>
                        <p class="card-text-pdf">
                          <strong>TOTAL VU:</strong>
                          <span class="texto_menu_desk_pdf">{{
                            this.currency(this.valor_avaliacao)
                          }}</span>
                        </p>
                        <p class="card-text-pdf">
                          <strong>FINANCIAMENTO:</strong
                          ><span class="texto_menu_desk_pdf">{{
                            g_menu_total_financiado
                          }}</span>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="card card-pdf border-secondary mb-1">
                      <div class="card-header header_pdf_txt">
                        <i class="bi bi-chat-square-text-fill ico-pdf"></i>
                        OBSERVAÇÕES
                      </div>
                      <div class="card-body text-secondary">
                        <p class="card-text-pdf">
                          <span class="texto_menu_desk_pdf">{{
                            info_adicionais
                          }}</span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Opções de Financiamento-->

                <div class="row g-2">
                  <div class="col-3">
                    <div class="card card-pdf-1 border-secondary">
                      <div class="card-header header_pdf_txt">
                        <i class="bi bi-wallet2 ico-pdf"></i>ENTRADAS
                      </div>
                      <div class="card-body">
                        <div class="row">
                          <div>
                            <div class="col texto_menu_desk_pdf-2">
                              <strong> {{ Entrada_Total_1 }}</strong>
                            </div>
                            <div class="col texto_menu_desk_pdf-2">
                              <strong> {{ Entrada_Total_2 }}</strong>
                            </div>
                            <div class="col texto_menu_desk_pdf-2">
                              <strong> {{ Entrada_Total_3 }}</strong>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-3">
                    <div class="card card-pdf-1 border-secondary">
                      <div class="card-header header_pdf_txt">
                        <i class="bi bi-calendar-check ico-pdf"></i>
                        {{ parcela_1 }} Meses
                      </div>
                      <div class="card-body">
                        <div class="row">
                          <div>
                            <div class="col texto_menu_desk_pdf-2">
                              <strong> {{ parcela_1_1 }}</strong>
                            </div>
                            <div class="col texto_menu_desk_pdf-2">
                              <strong> {{ parcela_1_2 }}</strong>
                            </div>
                            <div class="col texto_menu_desk_pdf-2">
                              <strong> {{ parcela_1_3 }}</strong>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-3">
                    <div class="card card-pdf-1 border-secondary">
                      <div class="card-header header_pdf_txt">
                        <i class="bi bi-calendar-check ico-pdf"></i>
                        {{ parcela_2 }} Meses
                      </div>
                      <div class="card-body">
                        <div class="row">
                          <div>
                            <div class="col texto_menu_desk_pdf-2">
                              <strong> {{ parcela_1_2 }}</strong>
                            </div>
                            <div class="col texto_menu_desk_pdf-2">
                              <strong> {{ parcela_2_2 }}</strong>
                            </div>
                            <div class="col texto_menu_desk_pdf-2">
                              <strong> {{ parcela_3_2 }}</strong>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-3">
                    <div class="card card-pdf-1 border-secondary">
                      <div class="card-header header_pdf_txt">
                        <i class="bi bi-calendar-check ico-pdf"></i>
                        {{ parcela_3 }} Meses
                      </div>
                      <div class="card-body">
                        <div class="row">
                          <div>
                            <div class="col texto_menu_desk_pdf-2">
                              <strong> {{ parcela_1_3 }}</strong>
                            </div>
                            <div class="col texto_menu_desk_pdf-2">
                              <strong> {{ parcela_2_3 }}</strong>
                            </div>
                            <div class="col texto_menu_desk_pdf-2">
                              <strong> {{ parcela_3_3 }}</strong>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!--Mensagem Rodapé-->
                <div class="row g-2 p-2">
                  <div class="col-md-12 col-lg-12 col-xl-12">
                    <p
                      class="card-text-2"
                      v-for="(text, index) in disclaimer_texts"
                      :key="index"
                    >
                      {{ text }}
                    </p>
                  </div>
                </div>

                <div class="row g-2 p-2 mt-1">
                  <div class="col rf_assinatura">
                    <span class="texto_menu_desk_pdf"
                      ><strong>Gerente:</strong> {{ g_menu_gerente }}</span
                    >
                  </div>
                  <div class="col rf_assinatura">
                    <span class="texto_menu_desk_pdf"
                      ><strong>Cliente:</strong> {{ g_menu_cliente }}</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-footer">
        <div class="row">
          <div class="col-md-6 col-lg-6 col-xl-6">
            <button
              type="button"
              class="btn btn-secondary"
              onclick="window.location.href='/desk/indexGerente'"
            >
              Fechar
            </button>
          </div>
          <div class="col-md-6 col-lg-6 col-xl-6">
            <button
              class="btn btn-secondary"
              :disabled="btn_gerar_menu"
              @click="generatePdf"
            >
              IMPRIMIR
            </button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="this.venda_perdida">
      <div class="modal-dialog modal-fullscreen rf_modal font-pdf-menu">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <div class="container_pdf" ref="contentToPrint">
              <div class="card-body">
                <div class="row">
                  <div class="col-6">
                    <a class="navbar-brand logo">
                      <img
                        src="../../assets/logo.png"
                        alt="Bootstrap"
                        class="logo-pdf"
                      />
                    </a>
                  </div>
                  <div class="col-6" style="text-align: right">
                    <a class="navbar-brand logo_cliente">
                      <img
                        src="../../assets/logo.png"
                        alt="Bootstrap"
                        class="logo-pdf"
                      />
                    </a>
                  </div>
                </div>
                <!-- Primeiro Bloco-->
                <div class="row g-2">
                  <div class="col-4">
                    <div class="card card-pdf border-secondary mb-1">
                      <div class="card-header header_pdf_txt">
                        <i class="bi bi-person-bounding-box ico-pdf"></i>
                        Informações do Cliente
                      </div>
                      <div class="card-body">
                        <p class="card-text-pdf">
                          <strong>CLIENTE:</strong>
                          <span class="texto_menu_desk_pdf">{{
                            g_menu_cliente
                          }}</span>
                        </p>
                        <p class="card-text-pdf">
                          <strong>CPF/CNPJ:</strong>
                          <span class="texto_menu_desk_pdf">{{
                            g_menu_cpfCnpj
                          }}</span>
                        </p>
                        <p class="card-text-pdf">
                          <strong>FONE:</strong>
                          <span class="texto_menu_desk_pdf">{{
                            g_menu_fone
                          }}</span>
                          /
                          <span class="texto_menu_desk_pdf">{{
                            g_menu_fone2
                          }}</span>
                        </p>

                        <p class="card-text-pdf">
                          <strong>EMAIL:</strong>
                          <span class="texto_menu_desk_pdf">{{
                            g_menu_email
                          }}</span>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="col-3">
                    <div class="card card-pdf border-secondary mb-2">
                      <div class="card-header header_pdf_txt">
                        <i class="bi bi-file-earmark-text ico-pdf"></i>
                        Informações da Proposta
                      </div>
                      <div class="card-body">
                        <p class="card-text-pdf">
                          <strong>GERENTE:</strong
                          ><span class="texto_menu_desk_pdf">{{
                            g_menu_gerente
                          }}</span>
                        </p>
                        <p class="card-text-pdf">
                          <strong>VENDEDOR:</strong
                          ><span class="texto_menu_desk_pdf">{{
                            g_menu_vendedor
                          }}</span>
                        </p>
                        <p class="card-text-pdf">
                          <strong>NEGOCIAÇÃO:</strong
                          ><span class="texto_menu_desk_pdf">{{
                            g_menu_negociacao
                          }}</span>
                        </p>
                        <p class="card-text-pdf">
                          <strong>DATA:</strong
                          ><span class="texto_menu_desk_pdf">{{
                            g_menu_data_negociacao
                          }}</span>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="col-5">
                    <div class="card card-pdf border-secondary mb-2">
                      <div class="card-header header_pdf_txt">
                        <i class="bi bi-car-front-fill ico-pdf"></i>
                        Veículo de Troca
                      </div>
                      <div>
                        <ul class="list-group">
                          <li
                            v-for="item in veiculos_avaliados"
                            :key="item.id"
                            class="list-group-item texto_menu_desk_pdf"
                          >
                            <div class="row">
                              <div class="col">
                                <span class="header_pdf_txt">Marca</span>
                              </div>
                              <div class="col">
                                <span class="header_pdf_txt">Modelo</span>
                              </div>
                              <div class="col">
                                <span class="header_pdf_txt">Placa</span>
                              </div>
                              <div class="col">
                                <span class="header_pdf_txt">Avaliado</span>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col">
                                <span class="texto_menu_desk_pdf">{{
                                  item.marca
                                }}</span>
                              </div>
                              <div class="col">
                                <span class="texto_menu_desk_pdf">{{
                                  item.modelo
                                }}</span>
                              </div>
                              <div class="col">
                                <span class="texto_menu_desk_pdf">{{
                                  item.placa
                                }}</span>
                              </div>
                              <div class="col">
                                <span class="texto_menu_desk_pdf">{{
                                  item.preco_avaliado
                                }}</span>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Segundo Bloco-->
                <div class="row g-2">
                  <div class="col-4">
                    <div class="card card-pdf border-secondary mb-1">
                      <div class="card-header header_pdf_txt">
                        <i class="bi bi-card-checklist ico-pdf"></i>
                        INFORMAÇÕES DO VEÍCULO
                      </div>
                      <div class="card-body text-secondary">
                        <p class="card-text-pdf">
                          <strong>MARCA:</strong
                          ><span class="texto_menu_desk_pdf">{{
                            g_menu_marca
                          }}</span>
                        </p>
                        <p class="card-text-pdf">
                          <strong>MODELO:</strong>
                          <span class="texto_menu_desk_pdf">{{
                            g_menu_modelo
                          }}</span>
                        </p>
                        <p class="card-text-pdf">
                          <strong>COR:</strong
                          ><span class="texto_menu_desk_pdf">{{
                            g_menu_cor
                          }}</span>
                        </p>
                        <div class="row">
                          <div class="col-5">
                            <p class="card-text-pdf">
                              <strong>PLACA:</strong>
                              <span class="texto_menu_desk_pdf">{{
                                g_menu_placa
                              }}</span>
                            </p>
                          </div>
                          <div class="col-7">
                            <p class="card-text-pdf">
                              <strong>CHASSI:</strong
                              ><span class="texto_menu_desk_pdf">{{
                                g_menu_chassi
                              }}</span>
                            </p>
                          </div>
                        </div>

                        <p class="card-text-pdf">
                          <strong>ANO:</strong
                          ><span class="texto_menu_desk_pdf">{{
                            g_menu_ano_modelo
                          }}</span>
                          /
                          <span class="texto_menu_desk_pdf">{{
                            g_menu_ano_fab
                          }}</span>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="card card-pdf border-secondary mb-1">
                      <div class="card-header header_pdf_txt">
                        <i class="bi bi-receipt-cutoff ico-pdf"></i>
                        RESUMO DA COMPRA
                      </div>
                      <div class="card-body text-secondary">
                        <p class="card-text-pdf">
                          <strong>VALOR SUGERIDO:</strong
                          ><span class="texto_menu_desk_pdf">{{
                            g_menu_val_sugerido
                          }}</span>
                        </p>
                        <p class="card-text-pdf">
                          <strong>DESCONTO:</strong
                          ><span class="texto_menu_desk_pdf">{{
                            g_menu_val_desconto
                          }}</span>
                        </p>

                        <p class="card-text-pdf">
                          <strong>TOTAL VEÍCULO:</strong>
                          <span class="texto_menu_desk_pdf">{{
                            g_menu_val_veiculo
                          }}</span>
                        </p>
                        <p class="card-text-pdf">
                          <strong>TOTAL VU:</strong>
                          <span class="texto_menu_desk_pdf">{{
                            this.currency(this.valor_avaliacao)
                          }}</span>
                        </p>
                        <p class="card-text-pdf">
                          <strong>FINANCIAMENTO:</strong
                          ><span class="texto_menu_desk_pdf">{{
                            g_menu_total_financiado
                          }}</span>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="card card-pdf border-secondary mb-1">
                      <div class="card-header header_pdf_txt">
                        <i class="bi bi-chat-square-text-fill ico-pdf"></i>
                        OBSERVAÇÕES
                      </div>
                      <div class="card-body text-secondary">
                        <p class="card-text-pdf">
                          <span class="texto_menu_desk_pdf">{{
                            info_adicionais
                          }}</span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Opções de Financiamento-->

                <div class="row g-2">
                  <div class="col-3">
                    <div class="card card-pdf-1 border-secondary">
                      <div class="card-header header_pdf_txt">
                        <i class="bi bi-wallet2 ico-pdf"></i>ENTRADAS
                      </div>
                      <div class="card-body">
                        <div class="row">
                          <div>
                            <div class="col texto_menu_desk_pdf-2">
                              <strong> {{ Entrada_Total_1 }}</strong>
                            </div>
                            <div class="col texto_menu_desk_pdf-2">
                              <strong> {{ Entrada_Total_2 }}</strong>
                            </div>
                            <div class="col texto_menu_desk_pdf-2">
                              <strong> {{ Entrada_Total_3 }}</strong>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-3">
                    <div class="card card-pdf-1 border-secondary">
                      <div class="card-header header_pdf_txt">
                        <i class="bi bi-calendar-check ico-pdf"></i>
                        {{ parcela_1 }} Meses
                      </div>
                      <div class="card-body">
                        <div class="row">
                          <div>
                            <div class="col texto_menu_desk_pdf-2">
                              <strong> {{ parcela_1_1 }}</strong>
                            </div>
                            <div class="col texto_menu_desk_pdf-2">
                              <strong> {{ parcela_1_2 }}</strong>
                            </div>
                            <div class="col texto_menu_desk_pdf-2">
                              <strong> {{ parcela_1_3 }}</strong>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-3">
                    <div class="card card-pdf-1 border-secondary">
                      <div class="card-header header_pdf_txt">
                        <i class="bi bi-calendar-check ico-pdf"></i>
                        {{ parcela_2 }} Meses
                      </div>
                      <div class="card-body">
                        <div class="row">
                          <div>
                            <div class="col texto_menu_desk_pdf-2">
                              <strong> {{ parcela_1_2 }}</strong>
                            </div>
                            <div class="col texto_menu_desk_pdf-2">
                              <strong> {{ parcela_2_2 }}</strong>
                            </div>
                            <div class="col texto_menu_desk_pdf-2">
                              <strong> {{ parcela_3_2 }}</strong>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-3">
                    <div class="card card-pdf-1 border-secondary">
                      <div class="card-header header_pdf_txt">
                        <i class="bi bi-calendar-check ico-pdf"></i>
                        {{ parcela_3 }} Meses
                      </div>
                      <div class="card-body">
                        <div class="row">
                          <div>
                            <div class="col texto_menu_desk_pdf-2">
                              <strong> {{ parcela_1_3 }}</strong>
                            </div>
                            <div class="col texto_menu_desk_pdf-2">
                              <strong> {{ parcela_2_3 }}</strong>
                            </div>
                            <div class="col texto_menu_desk_pdf-2">
                              <strong> {{ parcela_3_3 }}</strong>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!--Mensagem Rodapé-->
                <div class="row g-2 p-2">
                  <div class="col-md-12 col-lg-12 col-xl-12">
                    <p
                      class="card-text-2"
                      v-for="(text, index) in disclaimer_texts"
                      :key="index"
                    >
                      {{ text }}
                    </p>
                  </div>
                </div>

                <div class="row g-2 p-2 mt-1">
                  <div class="col rf_assinatura">
                    <span class="texto_menu_desk_pdf"
                      ><strong>Gerente:</strong> {{ g_menu_gerente }}</span
                    >
                  </div>
                  <div class="col rf_assinatura">
                    <span class="texto_menu_desk_pdf"
                      ><strong>Cliente:</strong> {{ g_menu_cliente }}</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-footer">
        <div class="row">
          <div class="col-md-6 col-lg-6 col-xl-6">
            <button
              type="button"
              class="btn btn-secondary"
              onclick="window.location.href='/desk/indexGerente'"
            >
              Fechar
            </button>
          </div>
          <div class="col-md-6 col-lg-6 col-xl-6">
            <button
              class="btn btn-secondary"
              :disabled="btn_gerar_menu"
              @click="generatePdf"
            >
              IMPRIMIR
            </button>
          </div>
        </div>
      </div>
    </div>
    <RodapeVue />
  </div>
</template>

<script>
import SidebarVue from "../../components/menu/Sidebar.vue";
import axios from "axios";
//import DataService from "../../services/DataService";
import userService from "../../services/user.service";
//import Pagination from "../../components/Pagination.vue";
//import Message from "../../components/modal/Message.vue";
//import MessageAtualizar from "../../components/modal/MessageAtualizar.vue";
import { VueMaskDirective } from "vue-the-mask";
import html2pdf from "html2pdf.js";
//import router from "../../router";
import TokenService from "../../services/token.service";
import jwt_decode from "jwt-decode";
import RodapeVue from "../../components/menu/Rodape.vue";
import NavgatorDk from "../../components/menu/NavgatorDk.vue";
//import Aviso from "../../components/modal/Modal.vue";
//import { Modal } from "bootstrap";

export default {
  name: "Usuários",

  components: {
    SidebarVue,
    NavgatorDk,
    RodapeVue
  },
  directives: {
    mask: VueMaskDirective
  },
  data() {
    return {
      a_vista: false,
      por_financiamento: false,
      venda_perdida: false,

      message: "",
      dialog: "",
      abrir_modal: false,
      abrir_modal_atualizar: false,
      info_adicionais: "",

      //Tabela Proposta
      id_proposta: "", // Armazena o id da Proposta
      propostas_at: [],
      itens_veiculo: [],
      veiculos_avaliados: [],
      estoque_veiculo: [],
      acessorios: [],
      itens_acessorios: [],
      marcas_estoque: [],
      modelos_estoque: [],
      cores_estoque: [],
      disclaimer_texts: [],

      desconto: "",
      acrescimo: "",
      searchTitle: "",
      searchChassi: "",
      searchPlaca: "",
      searchValIni: "",
      searchValFin: "",
      searchMarca: "",
      searchAnoMod: "",
      searchAnoFab: "",
      searchCor: "",
      tipoVeiculo: "",
      tipo_veiculo_escolhido: "",

      searchCodigo: "",
      searchDescricao: "",
      inserir_veiculo: true,

      item_p_avaliacao: "",
      valor_p_avaliacao: "",
      items_avaliacao: [{ value: "Débito" }, { value: "Crédito" }],
      valid: false,

      searchProposta: "",
      check_midia: "",

      tipo: "",

      habilitar_inserir_pagamento: false,
      habilitar_gerar_menu_avista: true,

      //Campos ref ao cliente
      cliente_id: "",
      cpfCnpj: "",
      cliente: "",
      dataNascimento: "",
      clientes: "",
      email: "",
      endereco: "",
      complemento: "",
      uf: "",
      cidade: "",
      bairro: "",
      cep: "",
      tel: "",
      cel: "",
      obs: "",
      initialCpfCnpj: "",
      clienteFoundByCpfCnpjModal: null,
      cliente_update_disabled: false,
      modal_cliente_id: "",
      modal_cliente: "",
      modal_cpfCnpj: "",
      modal_dataNascimento: "",
      modal_email: "",
      modal_endereco: "",
      modal_complemento: "",
      modal_uf: "",
      modal_cidade: "",
      modal_bairro: "",
      modal_cep: "",
      modal_tel: "",
      modal_cel: "",
      model: null,
      model2: null,
      model3: null,
      model4: null,
      descriptionLimit: 60,
      descriptionLimit2: 60,
      descriptionLimit3: 60,
      descriptionLimit4: 60,
      entries: [],
      entries2: [],
      entries3: [],
      entries4: [],
      modelo: [],
      marca: [],
      isLoading: false,
      search: null,
      isLoading4: false,
      search4: null,
      totalItems4: null,
      isLoading3: false,
      search3: null,
      totalItems3: null,
      isLoading2: false,
      search2: null,
      totalItems2: null,
      midia: [],
      midia_informada: "",
      midia_alterada: "",
      midia_id: "",
      page_midia: 1,
      totalPages_midia: 0,
      totalItems_midia: 0,
      pageSizes_midia: 1000,
      pageSize_midia: 1000,

      //Campos Veículo para troca
      marca_avaliacao: "",
      marca_avaliacao_desc: "",
      modelo_avaliacao: "",

      placa_avaliacao: "",
      placa_av: "",
      placa_av_hst: "",
      valor_av_hst: "",
      kilometragem_av_hst: "",
      valor_av: "",
      kilometragem_av: "",
      anoModelo_av: "",
      cor_av: "",
      obs_av: "",
      valor_avaliacao: "",
      kilometragem: "",
      anoModelo_avaliacao: "",
      anoFabricacao_avaliacao: "",
      dialog_avaliacao: false,
      avaliacoes: "",
      info_avaliacao: "",
      hab_avaliacao: true,
      ativar_placa: false,
      desativar_placa: true,
      cor_avaliacao: "",
      marcaSelecionada: "",
      marcas: [],
      modelos: [],
      id_veiculo: "",
      lastClicked: "",
      placaCorBorda: "",
      marcaCorBorda: "",
      modeloCorBorda: "",
      anoModeloCorBorda: "",
      corCorBorda: "",
      kilometragemCorBorda: "",
      valorAvaliadoCorBorda: "",

      //Campos Veículo compra
      chassi_proposta: "",
      marca_proposta: "",
      modelo_proposta: "",
      cor_proposta: "",
      anoModelo_proposta: "",
      anoFabricacao_proposta: "",
      combustivel_proposta: "",
      numero_veiculo_proposta: "",
      propostaVeiculo_id: "",
      inserir_acessorios: true,

      venda_Futura: "",
      venda_futura: "",
      empresa: "",
      categoria: "",
      pps_valor: "",
      valor_veiculo: "",
      dias_em_estoque: "",
      placa: "",
      status_veiculo: "",

      //Acessorios
      descricaoAcessorio: "",
      valorAcessorio: "",
      custoAcessorio: "",

      ///Modais
      hab_cliente: true,
      modal: false,
      modal_estoque: false,
      modal_itens_avaliacao: false,
      modal_itens_acessorios: false,
      modal_ranqueamento: false,
      modal_gerar_menu_desk: false,
      modal_proposta: false,

      //Campos para calcular as parcelas
      parcela: [],
      parcela_1: 24,
      parcela_2: 36,
      parcela_3: 48,
      entrada_1: "",
      entrada_2: "",
      entrada_3: "",
      entrada_1_original: "",
      entrada_2_original: "",
      entrada_3_original: "",
      id_coluna: "",
      valor_total: "",
      parcelamento: [],
      parcelamento_1: [],
      parcelamento_2: [],
      parcelamento_3: [],
      valor_financiado: "",
      valor_entrada: "",
      valor_financiado_2: "",
      valor_entrada_2: "",
      valor_financiado_3: "",
      valor_entrada_3: "",
      Valor_Entrada_2: "",
      Valor_Entrada_3: "",
      Valor_Financiado_2: "",
      Valor_Financiado_3: "",
      entrada_perc_1_padronizada: "",
      entrada_perc_2_padronizada: "",
      entrada_perc_3_padronizada: "",

      //Campos Filtro Ranqueamento
      filtro_tipo_veiculo: "",
      filtro_tipo_tabela: "SIM",
      filtro_spf: "SIM",
      filtro_param: "RENTABILIDADE",

      //Primeira coluna botões
      parcela_1_1: 0.0,
      parcela_2_1: 0.0,
      parcela_3_1: 0.0,
      //Segunda Coluna botões
      parcela_1_2: 0.0,
      parcela_2_2: 0.0,
      parcela_3_2: 0.0,
      //Terceira Coluna botões
      parcela_1_3: 0.0,
      parcela_2_3: 0.0,
      parcela_3_3: 0.0,

      //Resumo
      //Valores do veículo
      Valor_Sugerido: 0.0,
      Valor_Custo_variaveis: 0.0,
      Valor_Itens_Acessorios: 0.0,
      Valor_Total_Venda: 0.0,

      //Valores da Avaliação
      Valor_Avaliado: 0.0,
      Valor_Itens_Avaliacao_db: 0.0,
      Valor_Itens_Avaliacao_cr: 0.0,
      Valor_Avaliacao_Final: 0.0,

      //Resultado Operacional / Gerencial
      Lucro_Bruto: 0.0,
      Lucro_Operacional: 0.0,
      Lucro_liquido: 0.0,
      Valor_Resultado_Financiamento: 0.0,

      //Informações Financiamento
      Valor_Entrada: 0.0,
      Valor_Financiado: 0.0,
      Quantidade_Meses: 0.0,
      Pmt: 0.0,
      pagamento: false,

      //Gráficos Desk Veiculos Novos
      qtd_clientes_novos_n: 0,
      qtd_clientes_retorno_n: 0,
      qtd_vendas_perdidas_n: 0,
      qtd_vendas_realizadas_n: 0,
      qtd_clientes_novos_n_int: 0,
      qtd_clientes_retorno_n_int: 0,
      qtd_vendas_perdidas_n_int: 0,
      qtd_vendas_realizadas_n_int: 0,

      //Gráfico Desk Veículos Usados
      qtd_clientes_novos_u: 0,
      qtd_clientes_retorno_u: 0,
      qtd_vendas_perdidas_u: 0,
      qtd_vendas_realizadas_u: 0,
      qtd_clientes_novos_u_int: 0,
      qtd_clientes_retorno_u_int: 0,
      qtd_vendas_perdidas_u_int: 0,
      qtd_vendas_realizadas_u_int: 0,

      inserir_item_avaliacao: true,
      btn_ranquear: true,
      btn_1: true,
      btn_2: true,
      btn_3: true,
      btn_gerar_menu: true,
      btn_finalizar_venda: true,
      btn_finalizar_venda_vista: true,
      cortesia: "",

      icon_1: "",
      icon_2: "",
      icon_3: "",
      icon_4: "",
      icon_5: "",
      icon_6: "",
      icon_7: "",
      icon_8: "",
      icon_9: "",
      icon_10: "",
      icon_11: "",
      btn_filtro_1: "",
      btn_filtro_2: "",
      btn_filtro_3: "",
      btn_filtro_4: "",
      btn_filtro_5: "",
      btn_filtro_6: "",
      btn_filtro_7: "",
      btn_filtro_8: "",
      btn_filtro_9: "",
      btn_filtro_10: "",
      btn_filtro_11: "",

      incluir_acessorios: true,

      //Gerar Menu
      //informações cliente
      dados_menu: "",
      g_menu_cliente: "",
      g_menu_cpfCnpj: "",
      g_menu_fone: "",
      g_menu_fone2: "",
      g_menu_email: "",
      //informações proposta
      g_menu_gerente: "",
      g_menu_vendedor: "",
      g_menu_vendedor_id: "",
      g_menu_negociacao: "",
      g_menu_data_negociacao: "",
      //opções de compra
      g_menu_val_sugerido: "",
      g_menu_val_desconto: "",
      g_menu_val_veiculo: "",
      g_menu_total_financiado: "",
      //Dados veiculo compra
      g_menu_marca: "",
      g_menu_modelo: "",
      g_menu_cor: "",
      g_menu_chassi: "",
      g_menu_km: "",
      g_menu_ano_modelo: "",
      g_menu_ano_fab: "",
      g_menu_placa: "",
      //Dados veiculo troca
      g_menu_marca_avaliacao: "",
      g_menu_placa_avaliacao: "",
      g_menu_modelo_avalicao: "",
      g_menu_ano_modelo_avaliacao: "",
      g_menu_valor_avaliado: "",
      g_menu_itens_avaliacao_db: "",
      g_menu_itens_avaliacao_cr: "",
      g_menu_valor_avaliacao_final: "",
      //Acessorios
      g_menu_total_acessorios: "",
      total_vendas_usados: "",
      total_vendas_clientes_novos: "",
      total_vendas_clientes_retorno: "",
      total_vendas_perdidas_usados: "",

      atendimento_atrasado: "",
      atendimento_pontual: "",
      dialog_incluir_acessorios: false,
      message_incluir_acessorios: "",
      msg: "",
      msg_atualizar: "",

      abrir_modal_desconto: false,
      abrir_modal_acrescimo: false,
      open_proposta: true,
      id_cliente: "",

      Entrada_Total_1: "",
      Entrada_Total_2: "",
      Entrada_Total_3: "",
      Valor_Financiado_1: "",
      Valor_Entrada_1: "",
      handlePageChange: "",
      items: [],
      user_logado: "",
      empresaID: "",
      status_proposta: "",
      data_ini: "",
      data_fim: "",
      entrada_1_perc: "",
      entrada_2_perc: "",
      entrada_3_perc: "",
      valor_sugerido_original: "",
      valor_custo_contabil: "",
      entrada_escolhida: "",
      //Daddos da Proposta
      dados_proposta: "",
      pmtSelected: null,
      selected_familia_veiculo_escolhido: [],
      selected_modelo_veiculo_escolhido: [],
      selected_cor_veiculo_escolhido: [],
      familia_veiculo_escolhido: "",
      modelo_veiculo_escolhido: "",
      cor_veiculo_escolhido: "",
      venda_a_vista: "",
      recepcionista: "",
      vendedor: [],
      vendedor_info: "",
      company_id: "",
      vendedor_inicial: "",
      vend_ini: "",
      status_vendedor: "",
      modelo_futuro: [],
      input_cliente: true,
      nomeBorderColor: "",
      emailBorderColor: "",
      telBorderColor: "",
      celBorderColor: "",
      cnpjBorderColor: "",
      dataNascimentoBorderColor: "",
      enderecoBorderColor: "",
      complementoBorderColor: "",
      ufBorderColor: "",
      cidadeBorderColor: "",
      bairroBorderColor: "",
      cepBorderColor: "",

      troca_vendedor: [],
      justificativa_vendedor: "",
      tipo_vendedor: 2,
      check_vend: true,
      vendedor_troca: "",
      bloquear_entrada: false,
      bloquear_entrada_botoes: false,
      timer: null,
      historico_avaliacoes: [],
      modeloSelecionado: "",
      data_av_hst: "",

      //Historico do Cliente
      id_historico_cliente: "",
      nome_historico_cliente: "",
      hist_cliente: [],
      modal_historico_cliente: false,
      showModal: false,
      modalMessage: "",
      info_erros: {},
      //Pagamento a vista
      itens_pagamentos: [],
      venda_vista: false,
      venda_financiamento: true,
      incluir_financiamento: true,
      valor_da_venda: "",
      metodo_pagamento_vista: [],
      met_pagamento_vista: "",
      valor_parcela_vista: "",
      qtd_parcela_vista: "",

      id_pagamento: "",
      pagamentoVistaJaChamado: false,
      id_pagamento_desk: "",
      hab_ranquear: true,

      //Mensagens de aviso
      hab_avista: false,
      hab_financiamento: false,
      forma_pagamento: false,
      cliente_pcd: "",
      metodo_pagamento: "",
      mesmo_veiculo: false,
      msg_conteudo: "",
      atendimento_anterior: "",
      previsao_faturamento: "",
      codigo_cliente:""
    };
  },
  mounted() {
    /**Ao abrir a tela de proposta chamar o método habilitar_proposta ele é responsável por startar o atendimento */
    this.getToken();
    this.habilitar_proposta();
     this.setDisclaimer();
    //this.retrieveMidia();
    //this.retrieveTipoPagamento();
    //this.buscar_marcas();
  },
  methods: {
    setDisclaimer() {
      switch (this.codigo_cliente) {
        case "grupoRioTokio":
          this.disclaimer_texts = [
            "* Fica o cliente ciente de que a compra e venda em questão está condicionada à disponibilidade do veículo pela fábrica e sujeita a reajuste no preço aqui pactuado, que ocorrendo será informado ao cliente antes do faturamento do veículo, podendo haver desistência em caso de não concordância, com devolução do sinal dado como princípio de pagamento.",

            "* A concessão do financiamento está condicionada à análise de crédito por parte da instituição financeira / O pagamento do IPVA do veículo desta proposta é de inteira responsabilidade do cliente / O veículo usado da troca deverá ser entregue nas mesmas condições descritas na avaliação em anexo.",

            "* Declaro-me ciente e informado de que meus dados pessoais serão objeto de atividades de tratamento pelo presente controlador e demais empresas de seu grupo econômico e parceiros comerciais aplicáveis à presente venda, inclusive inseridos em sistemas informatizados, com a finalidade de possibilitar o controle, gestão e cumprimento dos termos e regras estipulados no presente instrumento, bem como para o cumprimento de obrigações legais e regulamentares vigentes. Declaro-me ciente e informado de que meus dados poderão ser utilizados para ações de marketing, sendo-me facultado a qualquer tempo opor-me a tal operação pelos canais de contato do presente controlador destinados ao exercício dos direitos do titular."
          ];
          break;

        case "grupoBeni":
          this.disclaimer_texts = [
            "* O preço sugerido é válido enquanto durarem os veículos em estoque.",
            "* Despesa Operacional para preparação do veículo, é proibido condicionar desconto de bem à aquisição de seguro."
          ];
          break;

        default:
          this.disclaimer_texts = [
            "* O preço sugerido é válido enquanto durarem os veículos em estoque.",
            "* Despesa Operacional para preparação do veículo, é proibido condicionar desconto de bem à aquisição de seguro."
          ];
      }
    },
    /**Função 0001 */
    getToken() {
      const accessToken = TokenService.getLocalAccessToken();
      TokenService.getLocalRefreshToken();
      const user_log = TokenService.getUser();
      const decodedToken = jwt_decode(accessToken);
      this.company_id = decodedToken.company;
      this.user_log = user_log.id;
      this.codigo_cliente = decodedToken.codigo_cliente;
      console.log(
        "Função inicial onde armazeno os seguintes dados -------------- 0001 "
      );
      console.log("usuário : ", user_log.id);
      console.log("Token de Acesso : ", decodedToken);
      console.log("Empresa Logada :", this.company_id);
      console.log("Slug", this.codigo_cliente);
    },
    /**Função 0002 */
    async habilitar_proposta() {
      console.log("Habilitando a proposta");

      const propostaId = this.$route.params.id;

      try {
        await userService.getPropostaId(propostaId).then((response) => {
          this.dados_proposta = response.data;
          const tipo_pagamento = response.data.tipo_pagamento;
          if (tipo_pagamento == 0) {
            this.a_vista = true;
            this.por_financiamento = false;

            this.retrievePagamentosDesk();
            this.carregarDadosMenuVista();
            this.retrieveVeiculosAvaliacao();
          }
          if (tipo_pagamento == 1) {
            console.log("Pagamento por financiamento");
            this.por_financiamento = true;
            this.a_vista = false;
            this.carregarDadosMenu();
            this.retrieveVeiculosAvaliacao();
            this.resumo();
          }
          if (tipo_pagamento == null) {
            console.log("Venda Perdida");
            this.venda_perdida = true;
            this.por_financiamento = false;
            this.a_vista = false;
            this.carregarDadosMenu();
            this.retrieveVeiculosAvaliacao();
            this.resumo();
          }
          console.log("Dados", response.data);

          /**Bloco de dados com informações do cliente */
          const dados_cliente = {
            id_cliente: this.dados_proposta["cliente_id"],
            nome: this.dados_proposta.clientes["nome"],
            cpfCnpj: this.dados_proposta.clientes["cpfCnpj"],
            dataNascimento: this.formatarData(
              this.dados_proposta.clientes["nascimento"]
            ),
            email: this.dados_proposta.clientes["email"],
            endereco: this.dados_proposta.clientes["endereco"],
            complemento: this.dados_proposta.clientes["complemento"],
            uf: this.dados_proposta.clientes["uf"],
            cidade: this.dados_proposta.clientes["cidade"],
            bairro: this.dados_proposta.clientes["bairro"],
            cep: this.dados_proposta.clientes["cep"],
            tel: this.dados_proposta.clientes["tel"],
            cel: this.dados_proposta.clientes["cel"],
            midia: this.dados_proposta.midias["descricao"],
            cliente_pcd: this.dados_proposta["cliente_pcd"] == 1 ? "Sim" : "Não"
          };
          this.id_cliente = dados_cliente.id_cliente;
          //Alterações Histórico do cliente
          this.id_historico_cliente = dados_cliente.id_cliente;
          this.nome_historico_cliente = dados_cliente.nome;
          //*** */
          this.cliente = dados_cliente.nome;
          this.cpfCnpj = dados_cliente.cpfCnpj;
          if (this.cpfCnpj)
            this.initialCpfCnpj = this.cpfCnpj.replace(/[^0-9]/g, "");
          this.dataNascimento = this.formatarData(dados_cliente.dataNascimento);
          this.email = dados_cliente.email;
          this.endereco = dados_cliente.endereco;
          this.complemento = dados_cliente.complemento;
          this.uf = dados_cliente.uf;
          this.cidade = dados_cliente.cidade;
          this.bairro = dados_cliente.bairro;
          this.cep = dados_cliente.cep;
          this.tel = dados_cliente.tel;
          this.cel = dados_cliente.cel;
          this.midia_informada = dados_cliente.midia;
          this.cliente_pcd = dados_cliente.cliente_pcd;
          /** */

          /**Bloco de dados com informações da proposta */
          const info_proposta = {
            id_proposta: this.dados_proposta["id"],
            empresaID: this.dados_proposta["empresa_id"],
            info_adicionais: this.dados_proposta["obs"],
            status_proposta: this.dados_proposta["status_proposta"],
            recepcionista: this.dados_proposta.usuarios["username"],
            vendedor_info: this.dados_proposta.proposta_vendedores["username"]
          };
          this.id_proposta = info_proposta.id_proposta;
          this.empresaID = info_proposta.empresaID;
          this.info_adicionais = info_proposta.info_adicionais;
          this.status_proposta = info_proposta.status_proposta;
          this.recepcionista = info_proposta.recepcionista;
          this.vendedor_info = info_proposta.vendedor_info;
          /** */

          /**Bloco de dados com informações do resumo da proposta */
          const resumo_proposta = {
            adicional: this.dados_proposta["adicional"],
            desconto: this.dados_proposta["desconto"],
            acessorios: this.dados_proposta["acessorios"],
            impostos: this.dados_proposta["impostos"],
            cortesia: this.dados_proposta["cortesia"],
            custos_variaveis: this.dados_proposta["custos_variaveis"],
            val_sugerido_venda: this.dados_proposta["val_sugerido_venda"]
          };

          this.adicional = this.currency(resumo_proposta.adicional);
          this.desconto = this.currency(resumo_proposta.desconto);
          this.Valor_Total_Venda = this.currency(
            resumo_proposta.val_sugerido_venda
          );

          //Dados do Cliente

          console.log("Pagamento por financiamento", tipo_pagamento);
          //Dados do Veículo Usado
          if (this.dados_proposta.veiculoUsado_id != null) {
            this.marca_avaliacao =
              this.dados_proposta.veiculos_usados.modeloVeiculo.familiaVeiculo.marcaVeiculo.descricao;
            this.modelo_avaliacao =
              this.dados_proposta.veiculos_usados.modeloVeiculo.descricao;
            this.familia_avaliacao =
              this.dados_proposta.veiculos_usados.modeloVeiculo.familiaVeiculo.descricao;
            this.placa_avaliacao = this.dados_proposta.veiculos_usados.placa;
            this.kilometragem = this.numberToReal(
              this.dados_proposta.veiculos_usados.kilometragem
            );
            this.anoFabricacao_avaliacao =
              this.dados_proposta.veiculos_usados.anoFabricacao;
            this.anoModelo_avaliacao =
              this.dados_proposta.veiculos_usados.anoModelo;

            if (this.dados_proposta.avaliacaoVeiculo_id != null) {
              this.retrieveItensVeiculo();
              this.inserir_item_avaliacao = false;
              this.btn_avaliacao = false;
              this.inserir_veiculo = false;
            } else {
              this.inserir_veiculo = true; // Bloqueia a inserção de veiculo para compra até preencher a avaliação

              this.btn_avaliacao = false;
            }
          } else {
            this.inserir_veiculo = false;
            this.inserir_item_avaliacao = true;
            this.btn_avaliacao = true;
            this.verificar_avaliacao_id_proposta();
          }

          // //Dados do Veículo para Compra
          if (
            this.dados_proposta.propostaVeiculo_id != null &&
            this.dados_proposta.proposta_veiculo.status_veiculo == 1
          ) {
            this.chassi_proposta = this.dados_proposta.proposta_veiculo.chassis;
            this.marca_proposta = this.dados_proposta.proposta_veiculo.marca;
            this.modelo_proposta =
              this.dados_proposta.proposta_veiculo.modelo_veiculo;
            this.cor_proposta = this.dados_proposta.proposta_veiculo.cor;
            this.anoModelo_proposta =
              this.dados_proposta.proposta_veiculo.ano_modelo;
            this.anoFabricacao_proposta =
              this.dados_proposta.proposta_veiculo.ano_fabricacao;
            this.combustivel_proposta =
              this.dados_proposta.proposta_veiculo.combustivel;
            ///Alteração na linha de baixo dia 10/05/2023
            this.Valor_Sugerido = this.currency(
              this.dados_proposta.proposta_veiculo.valor_veiculo +
                this.acrescimo
            );
            this.valor_sugerido_original =
              this.dados_proposta.proposta_veiculo.valor_veiculo;
            this.inserir_acessorios = false;
            this.retrieveItensAcessorios();
          }

          //Resumo da Proposta
          this.modal_proposta = true;

          //this.retrieveVeiculosAvaliacao();
        });
      } catch (error) {
        this.abrir_modal = true;
        this.msg = error;
        setTimeout(() => (this.abrir_modal = false), 4000);
      }

      //Inserir Gerente
      const gerente_id = this.$store.state.auth.user.id;
      await fetch(
        `${process.env.VUE_APP_API_URL}proposta_update_gerente/${propostaId}`,
        {
          method: "PUT",

          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            gerente_id_alteracao: gerente_id
          })
        }
      ).then((data) => {
        if (!data.ok) {
          this.abrir_modal = true;
          this.msg = "Sistema sendo atualizado!";
          setTimeout(() => (this.abrir_modal = false), 4000);
          throw Error(data.status);
        }

        return data.json();
      });
    },

    async retrievePagamentosDesk() {
      const proposta_id = this.$route.params.id;
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API_URL}pagamento_desk`,
          {
            params: {
              proposta_id: proposta_id,
              status: 1,
              page: this.page - 1,
              size: this.pageSize
            }
          }
        );
        console.log("Composição do pagamento", response.data.rows);
        this.itens_pagamentos = response.data.rows;
      } catch (error) {
        this.hab_avista = true;
        this.msg = error;
        setTimeout(() => (this.hab_avista = false), 1000);
      }
    },

    /**Função 0005 */
    async resumo() {
      await fetch(`${process.env.VUE_APP_API_URL}taxas/resumo`, {
        method: "POST",

        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          proposta_id: this.$route.params.id
        })
      })
        .then((data) => {
          if (!data.ok) {
            throw Error(data.status);
          }
          return data.json();
        })
        .then((resposta) => {
          if (resposta["tipo_veiculo"] == "NOVO") {
            this.Lucro_Bruto = resposta["Lucro_Bruto_Zero"];
            this.Lucro_Operacional = resposta["Lucro_Operacional_Zero"];
            this.Lucro_liquido = resposta["Lucro_liquido_Zero"];
          }
          if (resposta["tipo_veiculo"] == "USADO") {
            this.Lucro_Bruto = resposta["Lucro_Bruto"];
            this.Lucro_Operacional = resposta["Lucro_Operacional"];
            this.Lucro_liquido = resposta["Lucro_liquido"];
          }
          (this.Valor_Sugerido = resposta["Valor_Sugerido"]),
            (this.Valor_Custo_variaveis = resposta["Valor_Custo_variaveis"]),
            (this.Valor_Itens_Acessorios = resposta["Valor_Itens_Acessorios"]);
          this.Valor_Total_Venda = resposta["Valor_Total_Venda"];

          this.Valor_Avaliacao_Final = this.currency(this.valor_avaliacao);

          this.Valor_Resultado_Financiamento =
            resposta["Valor_Resultado_Financiamento"];

          this.Valor_Entrada = resposta["Valor_Entrada"];
          this.Valor_Financiado = resposta["Valor_Financiado"];
          this.Quantidade_Meses = resposta["Quantidade_Meses"];

          this.Valor_Entrada_1 = resposta["Valor_Entrada_1"];
          this.Entrada_Total_1 = resposta["Entrada_Total_1"];
          this.Valor_Financiado_1 = resposta["Valor_Financiado_1"];
          this.Quantidade_Meses_1 = resposta["Quantidade_Meses_1"];

          this.Valor_Entrada_2 = resposta["Valor_Entrada_2"];
          this.Entrada_Total_2 = resposta["Entrada_Total_2"];
          this.Valor_Financiado_2 = resposta["Valor_Financiado_2"];
          this.Quantidade_Meses_2 = resposta["Quantidade_Meses_2"];

          this.Valor_Entrada_3 = resposta["Valor_Entrada_3"];
          this.Entrada_Total_3 = resposta["Entrada_Total_3"];
          this.Valor_Financiado_3 = resposta["Valor_Financiado_3"];
          this.Quantidade_Meses_3 = resposta["Quantidade_Meses_3"];

          this.Pmt = resposta["Pmt"];
          this.parcela_1_1 = resposta["Pmt_1"];
          this.parcela_2_1 = resposta["Pmt_2"];
          this.parcela_3_1 = resposta["Pmt_3"];
          this.parcela_1_2 = resposta["Pmt_4"];
          this.parcela_2_2 = resposta["Pmt_5"];
          this.parcela_3_2 = resposta["Pmt_6"];
          this.parcela_1_3 = resposta["Pmt_7"];
          this.parcela_2_3 = resposta["Pmt_8"];
          this.parcela_3_3 = resposta["Pmt_9"];
          if (resposta["Parcela1"]) {
            this.parcela_1 = resposta["Parcela1"];
            this.bloquear_entrada = true;
          }

          if (resposta["Parcela2"] === undefined) {
            this.parcela_2 = 36;
          } else {
            this.parcela_2 = resposta["Parcela2"];
          }
          if (resposta["Parcela3"] === undefined) {
            this.parcela_3 = 48;
          } else {
            this.parcela_3 = resposta["Parcela3"];
          }

          let v_entrada_1 = resposta["Entrada1"];
          let v_entrada_2 = resposta["Entrada2"];
          let v_entrada_3 = resposta["Entrada3"];
          this.entrada_1 = this.currency(v_entrada_1);
          this.entrada_2 = this.currency(v_entrada_2);
          this.entrada_3 = this.currency(v_entrada_3);
          this.adicional = resposta["Valor_Adicional"];
          this.desconto = resposta["Valor_Desconto"];

          if (resposta["incluir_acessorios"] == "1") {
            this.incluir_acessorios = true;
          } else {
            this.incluir_acessorios = false;
          }
          if (resposta["Pmt"] != "") {
            this.btn_gerar_menu = false;
            this.btn_1 = false;
          }
        });
    },

    formatarData(data) {
      // Divida a data em partes
      const partesData = data.split(" ")[0].split("-");
      const ano = parseInt(partesData[0], 10);
      const mes = parseInt(partesData[1], 10) - 1; // O mês começa em 0 no JavaScript
      const dia = parseInt(partesData[2], 10);

      const dataObj = new Date(ano, mes, dia);

      const ano1 = dataObj.getFullYear();
      const mes1 = String(dataObj.getMonth() + 1).padStart(2, "0"); // Mês começa em 0
      const dia1 = String(dataObj.getDate()).padStart(2, "0");
      return `${ano1}-${mes1}-${dia1}`;
    },

    generatePdfAvista() {
      const element = this.$refs.contentToPrint2;

      // Primeiro, faça um clone do elemento para evitar alterar o DOM original
      const clonedElement = element.cloneNode(true);

      // Aplique estilos temporários apenas para o PDF
      clonedElement.style.width = "297mm";
      clonedElement.style.height = "210mm";
      clonedElement.style.margin = "0";
      clonedElement.style.padding = "5mm";
      clonedElement.style.boxSizing = "border-box";

      // Ajuste os tamanhos de fonte para o PDF
      clonedElement.querySelectorAll(".rf_texto_pdf").forEach((el) => {
        el.style.fontSize = "8px";
      });
      clonedElement.querySelectorAll(".rf_titulo_pdf").forEach((el) => {
        el.style.fontSize = "12px";
      });
      clonedElement
        .querySelectorAll(".rf_titulo_destaque_pdf")
        .forEach((el) => {
          el.style.fontSize = "14px";
        });

      // Configurações otimizadas para html2pdf
      const options = {
        margin: 0,
        filename: "proposta-comercial.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: {
          scale: 2,
          useCORS: true,
          letterRendering: true,
          allowTaint: true
        },
        jsPDF: {
          unit: "mm",
          format: "a4",
          orientation: "landscape",
          compress: true
        },
        pagebreak: {
          avoid: ".avoid-break",
          before: ".page-break-before",
          after: ".page-break-after"
        }
      };

      // Adicione temporariamente o elemento clonado ao corpo
      document.body.appendChild(clonedElement);

      // Gere o PDF
      html2pdf()
        .from(clonedElement)
        .set(options)
        .save()
        .then(() => {
          // Remova o elemento clonado após a geração
          document.body.removeChild(clonedElement);
        });
    },
    generatePdf() {
      const element = this.$refs.contentToPrint;

      // Primeiro, faça um clone do elemento para evitar alterar o DOM original
      const clonedElement = element.cloneNode(true);

      // Aplique estilos temporários apenas para o PDF
      clonedElement.style.width = "297mm";
      clonedElement.style.height = "210mm";
      clonedElement.style.margin = "0";
      clonedElement.style.padding = "5mm";
      clonedElement.style.boxSizing = "border-box";

      // Ajuste os tamanhos de fonte para o PDF
      clonedElement.querySelectorAll(".rf_texto_pdf").forEach((el) => {
        el.style.fontSize = "8px";
      });
      clonedElement.querySelectorAll(".rf_titulo_pdf").forEach((el) => {
        el.style.fontSize = "12px";
      });
      clonedElement
        .querySelectorAll(".rf_titulo_destaque_pdf")
        .forEach((el) => {
          el.style.fontSize = "14px";
        });

      // Configurações otimizadas para html2pdf
      const options = {
        margin: 0,
        filename: "proposta-comercial.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: {
          scale: 2,
          useCORS: true,
          letterRendering: true,
          allowTaint: true
        },
        jsPDF: {
          unit: "mm",
          format: "a4",
          orientation: "landscape",
          compress: true
        },
        pagebreak: {
          avoid: ".avoid-break",
          before: ".page-break-before",
          after: ".page-break-after"
        }
      };

      // Adicione temporariamente o elemento clonado ao corpo
      document.body.appendChild(clonedElement);

      // Gere o PDF
      html2pdf()
        .from(clonedElement)
        .set(options)
        .save()
        .then(() => {
          // Remova o elemento clonado após a geração
          document.body.removeChild(clonedElement);
        });
    },

    async carregarDadosMenu() {
      try {
        const id = this.$route.params.id;

        const response = await fetch(
          `${process.env.VUE_APP_API_URL}gerar_menu/${id}`,
          {
            method: "post",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              id: id
            })
          }
        );

        if (!response.ok) {
          throw Error(response.status);
        }

        const data = await response.json();
        console.log("Carregando o menu", data);
        const createdAt = data?.data?.rows[0]?.createdAt;
        this.metodo_pagamento = "Financiamento";
        const cliente = data?.data?.rows[0]?.clientes || {};
        const veiculo = data?.data?.rows[0]?.proposta_veiculo || {};
        const veiculoAvaliacao = data?.data?.rows[0]?.veiculos_usados || {};

        // Informações do Cliente
        this.g_menu_cliente = cliente.nome ?? "";
        this.g_menu_cpfCnpj = cliente.cpfCnpj ?? "";
        this.g_menu_fone = cliente.tel ?? "";
        this.g_menu_fone2 = cliente.cel ?? "";
        this.g_menu_email = cliente.email ?? "";

        // Informações da Proposta
        this.g_menu_gerente = data?.data?.rows[0]?.gerentes?.username ?? "";
        this.g_menu_vendedor =
          data?.data?.rows[0]?.proposta_vendedores?.username ?? "";
        this.g_menu_negociacao = data?.data?.rows[0]?.id ?? "";
        this.g_menu_data_negociacao = createdAt
          ? new Date(createdAt).toLocaleDateString("pt-BR")
          : "";

        // Opções de Compra
        this.g_menu_val_sugerido = this.currency(
          parseFloat(data?.data?.rows[0]?.proposta_veiculo.valor_veiculo ?? 0) +
            parseFloat(data?.data?.rows[0]?.custos_variaveis ?? 0) +
            parseFloat(data?.data?.rows[0]?.adicional ?? 0)
        );
        this.g_menu_val_desconto = this.currency(
          data?.data?.rows[0]?.desconto ?? 0
        );

        this.g_menu_val_veiculo = this.currency(
          parseFloat(data?.data?.rows[0]?.proposta_veiculo.valor_veiculo ?? 0) +
            parseFloat(data?.data?.rows[0]?.custos_variaveis ?? 0) +
            parseFloat(data?.data?.rows[0]?.adicional ?? 0) -
            parseFloat(data?.data?.rows[0]?.desconto ?? 0)
        );
        this.g_menu_total_financiado = this.currency(
          parseFloat(data?.data?.rows[0]?.val_financiamento ?? 0) +
            parseFloat(data?.data?.rows[0]?.val_entrada_financiamento ?? 0)
        );

        // Dados veiculo compra
        this.g_menu_marca = veiculo.marca ?? "";
        this.g_menu_modelo = veiculo.modelo_veiculo ?? "";
        this.g_menu_cor = veiculo.cor ?? "";
        this.g_menu_chassi = veiculo.chassis ?? "";
        this.g_menu_ano_modelo = veiculo.ano_modelo ?? "";
        this.g_menu_ano_fab = veiculo.ano_fabricacao ?? "";
        this.g_menu_placa = veiculo.placa ?? "";

        // Dados veiculo troca
        this.g_menu_marca_avaliacao =
          veiculoAvaliacao.modeloVeiculo?.familiaVeiculo?.marcaVeiculo
            ?.descricao ?? "";
        this.g_menu_placa_avaliacao = veiculoAvaliacao.placa ?? "";
        this.g_menu_modelo_avaliacao =
          veiculoAvaliacao.modeloVeiculo?.descricao ?? "";
        this.g_menu_ano_modelo_avaliacao = veiculoAvaliacao.anoModelo ?? "";
        this.g_menu_valor_avaliado = this.Valor_Avaliado ?? 0;
        this.g_menu_itens_avaliacao_db = this.Valor_Itens_Avaliacao_db ?? 0;
        this.g_menu_itens_avaliacao_cr = this.Valor_Itens_Avaliacao_cr ?? 0;
        this.g_menu_valor_avaliacao_final = this.Valor_Avaliacao_Final ?? 0;

        // Acessorios
        this.g_menu_total_acessorios = this.Valor_Itens_Acessorios;
        this.itens_acessorios = data?.data?.rows[0]?.acessorios_proposta ?? [];
        this.info_adicionais = data?.data?.rows[0]?.obs ?? "";
        if (this.incluir_acessorios == true) {
          this.msg = "Valor incluso no financiamento!";
        } else {
          this.msg = "Valor não incluso no financiamento!";
        }
      } catch (error) {
        this.abrir_modal = true;
        this.msg = error;
        setTimeout(() => (this.abrir_modal = false), 4000);
      }
    },
    async carregarDadosMenuVista() {
      try {
        const id = this.$route.params.id;

        const response = await fetch(
          `${process.env.VUE_APP_API_URL}gerar_menu/${id}`,
          {
            method: "post",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              id: id
            })
          }
        );

        if (!response.ok) {
          throw Error(response.status);
        }

        const data = await response.json();
        console.log("dados a vista", data);
        const createdAt = data?.data?.rows[0]?.createdAt;

        //this.limpar_financiamento();
        const cliente = data?.data?.rows[0]?.clientes || {};
        const veiculo = data?.data?.rows[0]?.proposta_veiculo || {};
        const veiculoAvaliacao = data?.data?.rows[0]?.veiculos_usados || {};

        // Informações do Cliente
        this.g_menu_cliente = cliente.nome ?? "";
        this.g_menu_cpfCnpj = cliente.cpfCnpj ?? "";
        this.g_menu_fone = cliente.tel ?? "";
        this.g_menu_fone2 = cliente.cel ?? "";
        this.g_menu_email = cliente.email ?? "";

        // Informações da Proposta
        this.g_menu_gerente = data?.data?.rows[0]?.gerentes?.username ?? "";
        this.g_menu_vendedor =
          data?.data?.rows[0]?.proposta_vendedores?.username ?? "";
        this.g_menu_negociacao = data?.data?.rows[0]?.id ?? "";
        this.g_menu_data_negociacao = createdAt
          ? new Date(createdAt).toLocaleDateString("pt-BR")
          : "";

        // Opções de Compra
        this.g_menu_val_sugerido = this.currency(
          parseFloat(data?.data?.rows[0]?.proposta_veiculo.valor_veiculo ?? 0) +
            parseFloat(data?.data?.rows[0]?.custos_variaveis ?? 0) +
            parseFloat(data?.data?.rows[0]?.adicional ?? 0)
        );
        this.g_menu_val_desconto = this.currency(
          data?.data?.rows[0]?.desconto ?? 0
        );

        this.g_menu_val_veiculo = this.currency(
          parseFloat(data?.data?.rows[0]?.proposta_veiculo.valor_veiculo ?? 0) +
            parseFloat(data?.data?.rows[0]?.custos_variaveis ?? 0) +
            parseFloat(data?.data?.rows[0]?.adicional ?? 0) -
            parseFloat(data?.data?.rows[0]?.desconto ?? 0)
        );
        this.g_menu_total_financiado = this.currency(
          parseFloat(data?.data?.rows[0]?.val_financiamento ?? 0) +
            parseFloat(data?.data?.rows[0]?.val_entrada_financiamento ?? 0)
        );

        // Dados veiculo compra
        this.g_menu_marca = veiculo.marca ?? "";
        this.g_menu_modelo = veiculo.modelo_veiculo ?? "";
        this.g_menu_cor = veiculo.cor ?? "";
        this.g_menu_chassi = veiculo.chassis ?? "";
        this.g_menu_ano_modelo = veiculo.ano_modelo ?? "";
        this.g_menu_ano_fab = veiculo.ano_fabricacao ?? "";
        this.g_menu_placa = veiculo.placa ?? "";

        // Dados veiculo troca
        this.g_menu_marca_avaliacao =
          veiculoAvaliacao.modeloVeiculo?.familiaVeiculo?.marcaVeiculo
            ?.descricao ?? "";
        this.g_menu_placa_avaliacao = veiculoAvaliacao.placa ?? "";
        this.g_menu_modelo_avaliacao =
          veiculoAvaliacao.modeloVeiculo?.descricao ?? "";
        this.g_menu_ano_modelo_avaliacao = veiculoAvaliacao.anoModelo ?? "";
        this.g_menu_valor_avaliado = this.Valor_Avaliado ?? 0;
        this.g_menu_itens_avaliacao_db = this.Valor_Itens_Avaliacao_db ?? 0;
        this.g_menu_itens_avaliacao_cr = this.Valor_Itens_Avaliacao_cr ?? 0;
        this.g_menu_valor_avaliacao_final = this.Valor_Avaliacao_Final ?? 0;

        // Acessorios
        this.g_menu_total_acessorios = this.Valor_Itens_Acessorios;
        this.itens_acessorios = data?.data?.rows[0]?.acessorios_proposta ?? [];
        this.info_adicionais = data?.data?.rows[0]?.obs ?? "";
        if (this.incluir_acessorios == true) {
          this.msg = "Valor incluso no financiamento!";
        } else {
          this.msg = "Valor não incluso no financiamento!";
        }
      } catch (error) {
        this.abrir_modal = true;
        this.msg = error;
        setTimeout(() => (this.abrir_modal = false), 4000);
      }
    },

    formatarValor(valor) {
      this.entrada_1_original = this.entrada_1;
      this.entrada_2_original = this.entrada_2;
      this.entrada_3_original = this.entrada_3;

      if (!valor) return "";
      valor = valor.toString().replace(/\D/g, "");
      valor = (valor / 100).toFixed(2).replace(".", ",");
      valor = valor.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");

      return valor;
    },
    formatarKM(numero) {
      // Converter para string e remover quaisquer caracteres não numéricos
      const numeroString = numero.toString().replace(/\D/g, "");

      // Adicionar ponto a cada três dígitos, começando da direita
      const numeroFormatado = numeroString.replace(
        /\B(?=(\d{3})+(?!\d))/g,
        "."
      );

      return numeroFormatado;
    },

    async retrieveVeiculosAvaliacao() {
      try {
        const id_proposta = this.$route.params.id;
        userService.getVeiculosAvaliacaoId(id_proposta).then((response) => {
          var veiculo_av = [];
          var veiculo_av2 = [];
          const { rows } = response.data;
          const TotalAvaliacoes = response.data.totalPrecoAvaliacao;
          this.valor_avaliacao = TotalAvaliacoes;

          for (var i = 0; i < rows.length; i++) {
            var arr_it = {
              marca: rows[i]["veiculo_usado_avaliacao"]["marca"],
              modelo: rows[i]["veiculo_usado_avaliacao"]["modelo"],
              placa: rows[i]["veiculo_usado_avaliacao"]["placa"],
              preco_avaliado: this.currency(rows[i]["precoAvaliacao"]),
              cor: rows[i]["veiculo_usado_avaliacao"]["cor"],
              kilometragem: rows[i]["veiculo_usado_avaliacao"]["kilometragem"],
              ano_mod: rows[i]["veiculo_usado_avaliacao"]["anoModelo"]
            };
            veiculo_av = arr_it;
            veiculo_av2.push(veiculo_av);
          }

          this.veiculos_avaliados = veiculo_av2;
          console.log("veiculo avaliado", this.veiculos_avaliados);
        });
      } catch (error) {
        if (error.response.status == 400) {
          this.abrir_modal = true;
          this.msg = error.response.data.message;
          setTimeout(() => (this.abrir_modal = false), 4000);
        }
      }
    },

    async verificar_avaliacao_id_proposta() {
      await fetch(`${process.env.VUE_APP_API_URL}veiculo_usado_avaliacao_id`, {
        method: "POST",

        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          proposta_id: this.id_proposta
        })
      })
        .then((data) => {
          if (!data.ok) {
            throw Error(data.status);
          }

          return data.json();
        })
        .then((resposta) => {
          if (resposta.status != 1) {
            (this.placa_avaliacao = resposta.placa),
              (this.marca_avaliacao = resposta.marca),
              (this.modelo_avaliacao = resposta.modelo),
              (this.kilometragem = resposta.kilometragem),
              (this.anoModelo_avaliacao = resposta.anoModelo),
              (this.cor_avaliacao = resposta.cor_avaliacao),
              (this.avaliacoes = resposta),
              (this.info_avaliacao =
                "Existem avaliações para esse veículo, clique no botão info para visualizar!"),
              (this.inserir_item_avaliacao = false),
              (this.hab_avaliacao = false);
          } else {
            this.valor_avaliacao = this.currency(0.0);
            (this.info_avaliacao = "Não existe avaliação para esse veículo!"),
              (this.hab_avaliacao = true);
          }
        });
    },

    ///Acessorios
    getRequestParamsAcessorios(searchCodigo, searchDescricao, page, pageSize) {
      let params = {};
      if (searchCodigo) {
        params["codigo"] = searchCodigo;
      }
      if (searchDescricao) {
        params["descricao"] = searchDescricao;
      }
      if (page) {
        params["page"] = page - 1;
      }
      if (pageSize) {
        params["size"] = pageSize;
      }
      return params;
    },
    handlePageChangeItemAcessorio(value) {
      this.page = value;
      this.retrieveAcessorios();
    },
    handlePageSizeChangeItemAcessorio(size) {
      this.pageSize = size;
      this.page = 1;
      this.retrieveAcessorios();
    },

    habilitar_itens_acessorios() {
      this.retrieveAcessorios();
      this.modal_itens_acessorios = true;
      this.btn_ranquear = false;
    },
    async retrieveAcessorios() {
      try {
        const params = this.getRequestParamsAcessorios(
          this.searchCodigo,
          this.searchDescricao,
          this.page,
          this.pageSize
        );

        userService.getAcessorios(params).then((response) => {
          const { acessorios, totalPages } = response.data;
          this.acessorios = acessorios;
          this.totalPages = totalPages;
        });
      } catch (error) {
        if (error.response.status == 400) {
          this.abrir_modal = true;
          this.msg = error.response.data.message;
        }
      }
    },
    async retrieveItensAcessorios() {
      try {
        const id_proposta = this.id_proposta;
        userService.getItensAcessoriosId(id_proposta).then((response) => {
          var itens_ac = [];
          var itens_ac2 = [];
          const { rows, somaValor } = response.data;
          this.Valor_Itens_Acessorios = this.currency(somaValor);

          for (var i = 0; i < rows.length; i++) {
            var arr_ac = {
              id: rows[i]["id"],
              proposta_id: rows[i]["proposta_id"],
              cortesia: rows[i]["cortesia"],
              custo: this.currency(rows[i]["custo"]),
              valor: this.currency(rows[i]["valor"]),
              descricao: rows[i]["descricao"],
              createdAt: rows[i]["createdAt"],
              updatedAt: rows[i]["updatedAt"]
            };
            itens_ac = arr_ac;
            itens_ac2.push(itens_ac);
          }

          this.itens_acessorios = itens_ac2;
        });
      } catch (error) {
        if (error.response.status == 400) {
          this.abrir_modal = true;
          this.msg = error.response.data.message;
        }
      }
    },

    currency(number) {
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2
      }).format(number);
    },
    ParseFloat(str, val) {
      str = str.toString();
      str = str.slice(0, str.indexOf(".") + val + 1);
      return Number(str);
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return "";

      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");

      return `${year}-${month}-${day}`;
    }
  }
};
</script>
<style scoped>
/* Grid container */
.pagamento-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 0;
  border: 1px solid #dee2e6;
}

/* Cada item do pagamento */
.pagamento-item {
  border: 1px solid #dee2e6;
  padding: 6px 4px;
  text-align: center;
  background: #fff;
}

/* Cabeçalho do grid */
.pagamento-grid-header {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  background: #f8f9fa;
  font-weight: bold;
  border-bottom: 2px solid #dee2e6;
}

.pagamento-grid-header div {
  border-right: 1px solid #dee2e6;
  padding: 6px 4px;
  text-align: center;
  font-size: 11px;
}

/* Para PDF */
@media print {
  .pagamento-grid {
    grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  }

  .pagamento-item {
    font-size: 9px;
  }
}
</style>
